/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { AppConfigState } from '../../../state/appConfig/app-config.state';
import { DisclaimerSeen } from '../../state/auth.actions';
import { MatCard, MatCardHeader, MatCardTitle, MatCardContent } from '@angular/material/card';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'dash-gis-disclaimer',
    templateUrl: './disclaimer.component.html',
    styleUrls: ['./disclaimer.component.scss'],
    imports: [
        MatCard,
        MatCardHeader,
        MatCardTitle,
        MatCardContent,
        LayoutDirective,
        LayoutAlignDirective,
        MatButton,
    ],
})
export class DisclaimerComponent {
    constructor(private store: Store) {}

    public showLogin() {
        this.store.dispatch(new DisclaimerSeen());
    }

    get siteName() {
        return this.store.selectSnapshot(AppConfigState.siteName);
    }

    get siteDescription() {
        return this.store.selectSnapshot(AppConfigState.siteDescription);
    }
}
